import React, {Component} from 'react'
import './index.css'
import localization from "../../../config/localization"
import {
  setPageTitle
} from "../../../api-client/core/authentication/utils";
import {request} from "../../../api-client";
import BloomSpinner from "../../../assets/img/bloom_spinner_grey.gif";
import CategoryItem from "./CategoryItem";
import HomeSearchInput from "../../../components/Letflow/HomeSearchInput";

class SmartSearch extends Component {

  state = {
    width: window.innerWidth,
    contentCreatorTypes: [],
    availableContentCreatorTypes: [],
    gettingCreators: true,
    search: "",
  }

  componentDidMount = () => {
    setPageTitle(localization.get('title.smart_search'))
    document.getElementsByTagName("html")[0].scrollTop = 0;
    window.addEventListener('resize', this.setWindowsWidth)

    this.getContentCreatorTypes()
  }

  getContentCreatorTypes = () =>  request.contentCreatorType.getAll({
    filterBy: [
      {column: "type", filter: "talent"},
      {column: "smartSearch", filter: "true"}
    ]
  })
    .then(contentCreatorTypes => this.setState({contentCreatorTypes, gettingCreators: false, availableContentCreatorTypes: contentCreatorTypes}))

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.setWindowsWidth)
  }

  setWindowsWidth = () => this.setState({width: window.innerWidth})

  render = () => {
    if (this.state.gettingCreators){
      return (
        <div style={{ height: "100%", display: "flex", justifyContent: "center", alignContent: "center" }}>
          <img style={{width: 100, height: 100, marginTop: "calc(43vh - 30px)"}} src={BloomSpinner} alt="Loading logo"/>
        </div>
      )
    } else {
      return (
        <div className="smart-search-category-container" style={{textAlign: this.state.contentCreatorTypes.length > 2 && "left"}}>
          <HomeSearchInput
            value={this.state.search}
            placeholder={"searchbar.input_categories"}
            onSearch={value =>
              this.setState({
                search: value,
                availableContentCreatorTypes: this.state.contentCreatorTypes.filter(i =>
                  i.name.toLowerCase().includes(value.toLowerCase()) ||
                  (i.synonyms && i.synonyms.toLowerCase().includes(value.toLowerCase()))
                )
              })
            }
          />
          <div className={"smart-search-category-searchbar-container"}>
            {/*<AsyncSelect
              className={"smart-search-category-searchbar"}
              styles={{
                menu: base => ({
                  ...base,
                  zIndex: 10,
                  borderRadius: 4,
                }),
                valueContainer: base => ({
                  base,
                  paddingLeft: 30
                })
              }}
              theme={theme => {
                return ({
                  ...theme,
                  paddingLeft: 30,
                  colors: {...theme.colors, neutral0: "rgba(240, 240, 240, 1)"},
                  borderRadius: 30,
                  borderColor: "#ccc",
                })
              }}
              input={styles => ({
                ...styles,
              })}
              valueContainer={<Search style={{position: "absolute", zIndex:10}}/>}
              placeholder={localization.get('conversation.filter_users')}
              loadingMessage={() => localization.get('loading')}
              noOptionsMessage={() => localization.get('no_options')}
              onChange={e => this.setState({search: e})}
              value={this.state.search}
              defaultOptions
              isClearable={true}
              loadOptions={inputValue =>{
                let filters = [{column: "name", filter: inputValue}]
                return request.contentCreatorType.getAll({filterBy: filters})
                  .then(res => res.map(category => ({value: category.id, label: category.name})))
              }}
            />*/}
          </div>
            {this.state.availableContentCreatorTypes.sort((a, b) => a.name.localeCompare(b.name)).map(contentCreatorType =>
              <CategoryItem contentCreatorType={contentCreatorType} width={this.state.width}/>
            )}
        </div>
      )
    }
  }


}

export default SmartSearch;